export function catalogErrorMessage(error: unknown, fallback: string): string {
  if (typeof error !== "object" || error === null || !("response" in error)) return fallback;
  const response = error.response as { data?: { message?: unknown } } | undefined;
  return typeof response?.data?.message === "string" ? response.data.message : fallback;
}
